/**
 * Created by henian.xu on 2018/8/26.
 *
 */

export { default as Label } from './Label';
export { default as Extends } from './extends';
